import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import Element from 'element-ui'
import "element-ui/lib/theme-chalk/index.css";

import '@/assets/iconfont/iconfont.css'


import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style (>= Swiper 6.x)
import 'swiper/swiper-bundle.css'


Vue.use(VueAwesomeSwiper, /* { default options with global component } */)


router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.requireLogin)) {  // 判断该路由是否需要登录权限
        if (sessionStorage.getItem('loginInfo')) {  // 判断当前用户的登录信息loginInfo是否存在
            next();
        } else {
            next({
                path: '/'
            })
        }
    } else {
        next();
    }
})

Vue.use(Element, {
    size: 'small'
})



// import "@/assets/css/tailwind.css"
import "@/assets/css/common.scss"

Vue.config.productionTip = false




// commonConfig().then(res => {
//     store.dispatch('setConfigData', res)
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
// })

